import { observer } from 'mobx-react-lite'
import {
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Area,
  ComposedChart,
} from 'recharts'
import React from 'react'
import styles from 'pages/analytics/pages/conversations/ui/Chart/ui/styles.module.scss'
import type { ConversionDetailsChartDataStore } from './store/conversionDetailsChartDataStore'

interface ConversionDetailsLineChartProps {
  chartDataStore: ConversionDetailsChartDataStore
}

export const ConversionDetailsLineChart = observer(
  ({ chartDataStore }: ConversionDetailsLineChartProps) => {
    const { rechartsData } = chartDataStore

    if (!rechartsData.length) {
      return null
    }

    return (
      <div className={styles.chartContainer}>
        <ResponsiveContainer width='100%' height={300}>
          <ComposedChart data={rechartsData} margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
            <defs>
              <linearGradient id='colorGradient' x1='0' y1='0' x2='0' y2='1'>
                <stop offset='0%' stopColor='var(--content-brand-primary)' stopOpacity={0.3} />
                <stop offset='100%' stopColor='var(--content-brand-primary)' stopOpacity={0.05} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray='3 3' vertical={false} />
            <XAxis dataKey='name' interval='preserveStartEnd' minTickGap={1} />
            <YAxis />
            <Tooltip />
            <Area
              type='monotone'
              dataKey='total'
              stroke='var(--content-brand-primary)'
              fill='url(#colorGradient)'
              strokeWidth={0}
              tooltipType='none'
            />
            <Line
              type='monotone'
              dataKey='total'
              stroke='var(--content-brand-primary)'
              strokeWidth={2}
              name='Conversions'
              dot={false}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    )
  }
)
